import callApi from "./callApi"

const getCheckPolicy = () => {
    return new Promise(async (resolve, reject) => {
        const method = "get"
        const url = `${process.env.REACT_APP_API}/api/shade/auths/termncondition`
        const body = null
        const headers = null
        try {
            const request = await callApi(method, url, body, headers)
            resolve(request)
        } catch (error) {
            reject(error)
        }
    })
}

export default getCheckPolicy

// const checkWaitingForPaymentBooking = (data) => {
//     return new Promise(async (resolve, reject) => {
//         const url = `${process.env.REACT_APP_API_COVID19}/api/map-routes/check/booking`
//         const method = 'post'
//         const body = data
//         try {
//             const response = await callApi(method, url, body, null)
//             resolve(response)
//         } catch (error) {
//             reject(error)
//         }
//     })
// }

// export default checkWaitingForPaymentBooking